import { matchPath } from 'react-router-dom'

export const SCK_PARAM = 'HOTMART_MEM_CA'

class UrlUtils {
  static isMenuItemActive(pathPattern: string, pathname: string, exactMatch = true) {
    return !!matchPath({ path: pathPattern, caseSensitive: true, end: exactMatch }, pathname)
  }

  static isValid(url: string) {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$',
      'i'
    )

    return urlPattern.test(url)
  }

  static hasQueryParams(url: string) {
    return url.includes('?')
  }

  static addSckParam(url?: string) {
    if (!url) return

    if (UrlUtils.hasQueryParams(url)) {
      return `${url}&sck=${SCK_PARAM}`
    }

    return `${url}?sck=${SCK_PARAM}`
  }

  static getSlugFromUrl(url: string) {
    const URL_PATTERN = new RegExp('/club/([^/]+)', 'i')
    const { 1: slug } = url?.match(URL_PATTERN) || []

    return slug
  }
}

export default UrlUtils
